export const SUJETS_KEY = "m2hat_sujets_session";
export const SUJETS_HISTORY_KEY = "m2hat_sujets_history";

export const EXEMPLES = ["Une situation récente", "Une relation", "Une émotion", "Une pensée qui revient", "Une difficulté au travail", "Une difficulté familiale", "Une difficulté d'organisation", "Une situation que j'évite", "Quelque chose que je ne comprends pas chez moi", "Autre"];

export const IMPORTANCE = [
  { v: 1, label: "Peu important", desc: "Cela me gêne peu actuellement." },
  { v: 2, label: "Assez important", desc: "Cela me préoccupe, mais je parviens globalement à gérer." },
  { v: 3, label: "Important", desc: "Cela a un impact significatif sur ma vie ou mon bien-être." },
  { v: 4, label: "Très important", desc: "Cela occupe une place importante dans mes préoccupations ou mon fonctionnement." },
];
export const PRIORITE = [
  { v: 1, label: "Peut attendre", desc: "Je peux continuer à avancer sans m'en occuper immédiatement." },
  { v: 2, label: "À prévoir", desc: "Il serait utile de travailler ce sujet prochainement." },
  { v: 3, label: "Prioritaire", desc: "Ce sujet mérite d'être abordé rapidement." },
  { v: 4, label: "Très prioritaire", desc: "Ce sujet nécessite une attention rapide dans mon suivi actuel." },
];
export const IMPACTS = ["Mes émotions", "Mes pensées", "Mes comportements", "Mes relations", "Ma famille", "Mon travail", "Mes études", "Mon sommeil", "Mon organisation", "Ma confiance en moi", "Mon quotidien", "Autre"];
export const OBJECTIFS = ["Comprendre ce qui se passe", "Trouver une solution", "Diminuer ma souffrance", "Modifier une pensée", "Modifier un comportement", "Mieux gérer mes émotions", "Améliorer une relation", "Prendre une décision", "Apprendre une stratégie", "Mieux me comprendre", "Autre"];

export const NIVEAUX = [
  { id: "faible", min: 1, max: 3, label: "Urgence faible", carte: "À garder en tête", tag: "À garder en tête", color: "#2F7A55", bg: "#E4F5EC", dot: "🟢" },
  { id: "moderee", min: 4, max: 7, label: "Urgence modérée", carte: "À travailler prochainement", tag: "À travailler prochainement", color: "#B8781A", bg: "#FFF3D6", dot: "🟡" },
  { id: "elevee", min: 8, max: 11, label: "Urgence élevée", carte: "À prioriser", tag: "Prioritaire", color: "#C2410C", bg: "#FFEDD5", dot: "🟠" },
  { id: "tres-elevee", min: 12, max: 16, label: "Urgence très élevée", carte: "À traiter en priorité", tag: "Très prioritaire", color: "#B4483A", bg: "#FDE4DF", dot: "🔴" },
];

export const urgence = (s) => (s.importance || 0) * (s.priorite || 0);
export const niveauDe = (score) => NIVEAUX.find((n) => score >= n.min && score <= n.max) || NIVEAUX[0];
export const trier = (sujets) => [...sujets].sort((a, b) => urgence(b) - urgence(a) || (b.priorite - a.priorite) || (b.importance - a.importance) || (a.createdAt - b.createdAt));

export const feedbackText = (score) => ({
  "tres-elevee": "Ce sujet semble actuellement faire partie des thèmes à traiter en priorité dans votre suivi.",
  elevee: "Ce sujet mérite d'être abordé rapidement dans votre suivi.",
  moderee: "Ce sujet peut être travaillé progressivement, au fil des séances.",
  faible: "Ce sujet reste à garder en tête, sans caractère pressant pour l'instant.",
}[niveauDe(score).id]);

export const syntheseText = (sujets) => {
  const t = trier(sujets);
  if (!t.length) return "";
  const hauts = t.filter((s) => urgence(s) >= 8).length;
  const p = t[0];
  const n = t.length;
  return [
    `Vous avez identifié ${n} sujet${n > 1 ? "s" : ""} thérapeutique${n > 1 ? "s" : ""}.`,
    hauts ? `${hauts} sujet${hauts > 1 ? "s présentent" : " présente"} actuellement un niveau d'urgence thérapeutique élevé ou très élevé.` : "Aucun sujet ne présente actuellement un niveau d'urgence thérapeutique élevé.",
    `Votre sujet principal concerne « ${p.texte} », avec une importance de ${p.importance}/4 et une priorité de ${p.priorite}/4.`,
    n > 1 ? "D'autres sujets restent importants mais peuvent être travaillés progressivement." : "",
    "Cette synthèse peut vous aider à préparer votre prochaine séance.",
  ].filter(Boolean).join(" ");
};

export const newSujet = (texte = "") => ({ id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`, texte, importance: null, priorite: null, contexte: "", impacts: [], createdAt: Date.now() });
export const newSession = () => ({ sujets: [], objectif: "", objectifAutre: "", phrase: "", createdAt: Date.now() });
